import variables from '@app/theme/variables'

import type { TableOverrideToken } from './types'

const Table: TableOverrideToken = {
  borderRadiusSM: variables.borderRadiusS,
  borderRadius: variables.borderRadiusS,
  borderRadiusLG: variables.borderRadiusS,
  colorBorderSecondary: variables.gray20
} as const

export default Table
